const moment = require('moment');

export const filtro = () => {
  return {
    id_empresa: '',
    paginado: true,
    page: 1,
    perPage: 10,
    sortBy: 'id',
    sort: 'DESC',
  };
};

export const adjunto = () => {
  return {
    id_empresa: null,
    id_seguimiento: null,
    descripcion: null,
    archivo: null
  };
};

export const seguimiento = () => {
  return {
    id: null,
    id_empresa: null,
    id_hallazgo: null,
    fecha_seguimiento: moment().format('yyyy-MM-DD'),
    fecha_cierre: null,
    observacion: null,
    porc_implementacion: null,
    responsable: null,
    estado: 1,
    adjuntos: []
  };
};

export default {
  listas_chequeo: {
    data: []
  },
  hallazgos: {
    data: []
  },
  filtro_hallazgos: {
    id_empresa: null,
    id_lista: null,
    sort: 'ASC',
    sortBy: 'id',
    perPage: 10,
    page: 1
  },
  empresas: [],
  empresas_filtro: [],
  filtro: filtro(),
  modal_seguimiento: {
    mostrar: false
  },
  seguimientos: [],
  seguimiento: seguimiento(),
  adjuntos: [],
  accion: 'Crear',
  adjunto: adjunto()
};
